import React from 'react';
import { CatalogReplacementSearch } from '@/components/catalog-replacement-search';
import { InboundReducerAction } from '@/hooks/use-order-inbound-reducer';
import { InboundRenderAddActions } from './inbound-render-add-actions';
import { useEscapeKeyClose } from '@platform/shortcuts/hooks/use-escape-key-close';

export interface Props {
  dispatch: React.Dispatch<InboundReducerAction>;
  onClose?: () => void;
  smartOrderUUID: string;
}

export const AddInboundItemSearchContent: React.FC<Props> = ({
  dispatch,
  onClose,
  smartOrderUUID,
}) => {
  useEscapeKeyClose(onClose);

  return (
    <CatalogReplacementSearch
      filterTrackingKey="inbound_add_search.item_group_selector"
      isInboundOrder
      isModal
      onClose={onClose}
      renderActions={(sku) => (
        <InboundRenderAddActions
          dispatch={dispatch}
          item={sku}
          smartOrderUUID={smartOrderUUID}
        />
      )}
      searchParams={{
        includeOrderCounts: true,
        searchSource: 'inbound_add',
      }}
      showVariantPackOrderInfo
      skipListInteractionCheck
    />
  );
};
